import cadex from '@cadexchanger/web-toolkit'

// Callback for displaying created view3d objects on the scene.
export class ModelUserDefinedSceneDisplayer extends cadex.ModelPrs_Displayer {
  constructor(
    private scene: cadex.ModelPrs_Scene,
    private setView3dObject: (
      id: cadex.Base_Uuid,
      view3dObject: cadex.ModelPrs_View3dObject
    ) => void
  ) {
    super()
  }

  /**
   * @param {Array<ModelPrs_View3dObject>} theView3dObjects List of objects to display
   * @param {ModelData_Representation} theRepresentation The presentation which view3d object created for.
   * @param {Array<ModelData_SceneGraphElement>} theAncestors The valid path in scenegraph to the element which displayed.
   * @param {number} theDisplayMode Mode to display with.
   */
  display(
    theView3dObjects: Array<cadex.ModelPrs_View3dObject>,
    theRepresentation: cadex.ModelData_Representation,
    theAncestors: Array<cadex.ModelData_SceneGraphElement>,
    theDisplayMode: number
  ) {
    if (theView3dObjects) {
      theView3dObjects.forEach((obj) => {
        // eslint-disable-next-line
        obj['name'] = theAncestors[theAncestors.length - 1]?.name
        // eslint-disable-next-line
        obj['id'] = theAncestors[theAncestors.length - 1]?.uuid
        this.setView3dObject(theAncestors[theAncestors.length - 1].uuid, obj)
      })
    }

    this.scene.display(theView3dObjects, theDisplayMode)
  }
}
